module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-blue-lift",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps,
      "theme": "light"
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.remount
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [(_vm.$route.params.person === '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-first-skier')))]) : _vm._e(), _vm._v(" "), (_vm.$route.params.person !== '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-skier-x', {
    number: parseInt(_vm.$route.params.person) + 1
  })))]) : _vm._e(), _vm._v(" "), (_vm.$route.query.onlyseason === '1') ? _c('h1', [_vm._v("Säsongskort")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: 'content'
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("Välj typ av liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "center skipass-age-wrapper"
  }, _vm._l((_vm.options), function(option) {
    return ((!_vm.selectedAge || _vm.selectedAge === option.value)) ? _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.selectedAge === option.value),
          'has-description': (option.subtitle)
      },
      on: {
        "click": function($event) {
          return _vm.setAge(option.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n            "), _c('span', [_vm._v(_vm._s(option.subtitle))])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    class: 'content center ' + (_vm.selectedAge ? '' : 'disabled')
  }, [(!_vm.$store.state.isOnSite) ? _c('div', [(_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', [_vm._v("Antal dagar / säsongskort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.day_online && !_vm.SITE_CONFIG.skipass.season_online) ? _c('h2', [_vm._v("Antal dagar")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', [_vm._v("Välj Säsongskort")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('div', [(_vm.SITE_CONFIG.skipass.day_onsite && _vm.SITE_CONFIG.skipass.season_onsite) ? _c('h2', [_vm._v("Antal dagar / säsongskort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.day_onsite && !_vm.SITE_CONFIG.skipass.season_onsite) ? _c('h2', [_vm._v("Antal dagar")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.day_onsite && _vm.SITE_CONFIG.skipass.season_onsite) ? _c('h2', [_vm._v("Välj Säsongskort")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skipass.open) ? _c('div', {
    staticClass: "blocked"
  }, [_c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skipass.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skipass.open) ? _c('div', {
    staticClass: "blocked"
  }, [_c('Dropdown', {
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "options": _vm.days,
      "validated": _vm.selectedDays && _vm.selectedDays.value,
      "value": _vm.selectedDays,
      "label": (_vm.selectedDays && _vm.selectedDays.value) ? (_vm.selectedDays.title) : 'Välj liftkort',
      "with-background": true,
      "bold-label": true
    },
    on: {
      "changed": _vm.changedDate,
      "clicked-suffix": function($event) {
        return _vm.changedDate({})
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.selectedDays && _vm.selectedDays.value && _vm.selectedDays.value.indexOf('0') === 0) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isSeason) ? _c('div', {
    staticClass: "center"
  }, [(_vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas') ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen') ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(4), _vm._v(" "), _c('p', [_vm._v("Kampanjpriserna gäller fram till 14:e december.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Ta med bokningsnumret och visa i liftkortskassan första dagen du besöker oss (när vi har öppnat), du blir då fotograferad och får ditt nya säsongskort.")])]) : _vm._e(), _vm._v(" "), (['ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(_vm.SITE_CONFIG.site) !== -1) ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Ta med bokningsnumret och visa i liftkortskassan första dagen du besöker oss (när vi har öppnat), du blir då fotograferad och får ditt nya säsongskort.")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    class: 'content ' + ((_vm.selectedAge && _vm.selectedDays && _vm.selectedDays.value) ? '' : 'disabled')
  }, [_c('h2', {
    staticClass: "center",
    on: {
      "click": function($event) {
        return _vm.openModal(['SkipassInfo'])
      }
    }
  }, [(_vm.SITE_CONFIG.skipass.load_enabled && !_vm.isSeason) ? _c('span', [_vm._v("\n          Ladda ditt befintliga liftkort eller\n        ")]) : _vm._e(), _vm._v("\n        köp\n        "), (_vm.isSeason) ? _c('span', [_vm._v("\n          säsongskort och\n        ")]) : _vm._e(), _vm._v("\n        keycard\n        "), _c('icon', {
    staticStyle: {
      "margin-left": "0.2em",
      "cursor": "pointer"
    },
    attrs: {
      "name": "info-white",
      "scale": 1.4
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.products), function(product, key) {
    return ((!_vm.selectedType || _vm.selectedType === key) && ((key === 'load' && _vm.isSeason) ? false : true)) ? _c('div', {
      class: {
        button: true,
          'small-text': true,
          wide: true,
          underlined: true,
          checked: (_vm.selectedType === key),
          'has-description': (product.description)
      },
      on: {
        "click": function($event) {
          return _vm.setType(key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(product.title) + "\n          "), _c('span', [_vm._v(_vm._s(product.description))])]) : _vm._e()
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Vid köp av ett nytt säsongskort så hämtar du ut det på plats i Kungsbergets Infocenter och blir då fotograferad. Du kan också ladda ett Keycard som säsongskort via "), _c('a', {
    attrs: {
      "href": "http://ladda.kungsberget.se/"
    }
  }, [_vm._v("ladda.kungsberget.se")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Vid köp av ett nytt säsongskort så hämtar du ut det på plats i Branäs Infocenter och blir då fotograferad. Du kan också ladda ett Keycard som säsongskort via "), _c('a', {
    attrs: {
      "href": "http://ladda.branas.se/"
    }
  }, [_vm._v("ladda.branas.se")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00149406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiPass/SkiPassUser.vue
// module id = 868
// module chunks = 0